import clsx from 'clsx';
import { cva } from 'class-variance-authority';

const betBuilderPlusIconVariants = cva('symbol symbol--bet-builder-plus', {
	variants: {
		variant: {
			default: '',
			white: 'bet-builder-plus-icon-white',
			light: 'bet-builder-plus-icon-light',
		},
	},
	defaultVariants: {
		variant: 'default',
	},
});

interface BetBuilderPlusIconProps {
	className?: string;
	variant?: 'default' | 'white' | 'light';
}

export const BetBuilderPlusIcon = ({
	variant = 'default',
	className
}: BetBuilderPlusIconProps) => {
	return (
		<i className={clsx(betBuilderPlusIconVariants({ variant }), className)}></i>
	);
};